// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__4ilBv"};